var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewmetroLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 100,
    viewBox: "0 0 150 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0437 0.460859C24.7974 1.27714 19.538 22.0394 10.0331 59.7143C7.67429 69.0643 4.45171 81.8334 2.872 88.0903C1.29257 94.3469 0 99.5863 0 99.7332C0 99.8957 7.35886 100 18.8571 100C29.2286 100 37.7143 99.9217 37.7143 99.826C37.7143 99.6411 44.7654 71.6629 45.0429 70.7469C45.1729 70.3171 48.2223 73.2237 60.104 85.104L75.002 100L89.8506 85.1494C99.0766 75.9223 104.768 70.4317 104.881 70.6494C104.98 70.8423 106.709 77.5249 108.721 85.5L112.379 100H131.19C143.697 100 150 99.9031 150 99.7106C150 99.5514 148.851 94.8909 147.447 89.3534C141.569 66.1726 125.336 1.51057 125.212 0.785714C125.138 0.353714 124.996 0 124.895 0C124.795 0 113.528 11.1857 99.8571 24.8571L75.0012 49.7143L50.1037 24.818C30.3214 5.03657 25.1729 0.0325733 25.0437 0.460859Z",
    fill: "url(#paint0_radial_6_2)",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0437 0.460859C24.7974 1.27714 19.538 22.0394 10.0331 59.7143C7.67429 69.0643 4.45171 81.8334 2.872 88.0903C1.29257 94.3469 0 99.5863 0 99.7332C0 99.8957 7.35886 100 18.8571 100C29.2286 100 37.7143 99.9217 37.7143 99.826C37.7143 99.6411 44.7654 71.6629 45.0429 70.7469C45.1729 70.3171 48.2223 73.2237 60.104 85.104L75.002 100L89.8506 85.1494C99.0766 75.9223 104.768 70.4317 104.881 70.6494C104.98 70.8423 106.709 77.5249 108.721 85.5L112.379 100H131.19C143.697 100 150 99.9031 150 99.7106C150 99.5514 148.851 94.8909 147.447 89.3534C141.569 66.1726 125.336 1.51057 125.212 0.785714C125.138 0.353714 124.996 0 124.895 0C124.795 0 113.528 11.1857 99.8571 24.8571L75.0012 49.7143L50.1037 24.818C30.3214 5.03657 25.1729 0.0325733 25.0437 0.460859Z",
    fill: "#555555",
    fillOpacity: 0.43
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6_2",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-6.78771e-06 74.4286) rotate(-10.3642) scale(135.787 203.68)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#721E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294318,
    stopColor: "#9B3382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862853,
    stopColor: "#004BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013777"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewmetroLogoMini);
export default __webpack_public_path__ + "static/media/newmetroLogoMini.03cb04d01751b162227d0a632058b51a.svg";
export { ForwardRef as ReactComponent };